module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel06_1280_1280_ko-e306f17460c5476e6120aa8831ddb479.jpg";